<template>
  <v-row>
    <v-col>
      <v-card>
        <v-toolbar color="transparent" flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">
            <router-link :to="{name: 'BillersBuiltInSettings'}" class="subtitle-1 routerLink font-weight-medium">Facturación incorporada</router-link>
            <v-icon class="mx-1" color="secondary">mdi-chevron-right</v-icon>Reporte transaccional
          </v-toolbar-title>
        </v-toolbar>
        <v-divider />
        <v-card-text class="px-0 py-0">
          <!-- invoices status -->
          <v-row>
            <v-col cols="12" class="py-0">
              <v-toolbar color="transparent" flat height="48">
                <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Resultado de revisión SII</v-toolbar-title>
              </v-toolbar>
              <v-divider />
            </v-col>
          </v-row>
          <v-row>
            <template v-for="(status, i) in statusesInvoiceStatus">
              <v-col :key="`status-${i}`">
                <v-sheet class="py-5 py-0 text-center">
                  <v-progress-circular class="mb-6" v-if="loaderReport" indeterminate color="primary" :width="2" :size="24" />
                  <span class="d-block mb-4 headline text--secondary font-weight-regular" v-else>{{valuesInvoiceStatus[status.code] | number}}</span>
                  <span class="d-block body-1 text--secondary font-weight-medium">{{status.name}}</span>
                  <v-btn :to="{name: 'InvoiceList', query: {tax_agency__contains: status.routeQueryValue}}" exact color="primary" text small :ripple="false">Ver facturas</v-btn>
                </v-sheet>
              </v-col>
              <v-divider v-if="i < statusesInvoiceStatus.length - 1" :key="`status-divider-${i}`" vertical />
            </template>
          </v-row>
          <!-- end invoices status -->

          <!-- acknowledgment -->
          <v-row>
            <v-col cols="12" class="py-0">
              <v-divider />
              <v-toolbar color="transparent" flat height="48">
                <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Acuse de recibo</v-toolbar-title>
              </v-toolbar>
              <v-divider />
            </v-col>
          </v-row>
          <v-row>
            <template v-for="(status, i) in statusesAcknowledgment">
              <v-col :key="`status-${i}`">
                <v-hover v-slot="{hover}">
                  <v-sheet class="pt-5 py-0 text-center">
                    <v-progress-circular class="mb-6" v-if="loaderReport" indeterminate color="primary" :width="2" :size="24" />
                    <span class="d-block mb-4 headline text--secondary font-weight-regular" v-else>{{valuesAcknowledgment[status.code] | number}}</span>
                    <span class="d-block body-1 text--secondary font-weight-medium">{{status.code}}</span>
                    <span class="d-block body-2">{{status.name}}</span>
                    <v-btn :to="{name: 'BillersBuiltInReportTransactional', query: {code: status.code}}" exact :color="hover ? 'primary' : 'transparent'" text small :ripple="false">Filtrar registros</v-btn>
                  </v-sheet>
                </v-hover>
              </v-col>
              <v-divider v-if="i < statusesAcknowledgment.length - 1" :key="`status-divider-${i}`" vertical />
            </template>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-text class="pa-0">
          <v-skeleton-loader v-if="loaderList" transition="fade-transition" type="table" />
          <v-data-table v-else :headers="headers" :items="supplierresponsesList" :items-per-page="pagination" hide-default-header disable-sort mobile-breakpoint hide-default-footer @click:row="(supplierresponsesList) => {$router.push({name: 'InvoiceRetrieve', params: {id: supplierresponsesList.invoice.id}})}" style="cursor: pointer">
            <template v-slot:header="{props: {headers}}">
              <v-table-headers :headers="headers" @sort="setSort" />
            </template>
            <template v-slot:[`item.document`]="{item}">
              <span class="d-block">{{item.invoice.document.name}}</span>
              <span class="d-block body-2 text--secondary font-weight-medium">Nº {{item.invoice.number}}</span>
            </template>
            <template v-slot:[`item.status`]="{item}">
              <v-chip v-if="item.invoice.status === 'finalized'" class="mx-1" color="defaultGrey" text-color="secondary" small>Finalizado</v-chip>
              <v-chip v-else-if="item.invoice.status === 'paid'" class="mx-1" color="defaultGrey" text-color="secondary" small>Pagado<v-icon class="ml-1" x-small>mdi-check</v-icon></v-chip>
              <v-chip v-else-if="item.invoice.status === 'cancelled'" class="mx-1" color="defaultGrey" text-color="secondary" small>Tiene nota de crédito<v-icon class="ml-1" x-small>mdi-close</v-icon></v-chip>
            </template>
            <template v-slot:[`item.date`]="{item}">
              <span>{{item.invoice.date | date}}</span>
            </template>
            <template v-slot:[`item.total`]="{item}">
              <span class="body-2 text--secondary font-weight-medium">{{item.invoice.total | currency(item.invoice.currency)}}</span>
              <span class="ml-1">{{item.invoice.currency}}</span>
            </template>
          </v-data-table>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-0">
          <v-row class="pl-4 pr-3" align="center">
            <v-col cols="6">
              <span class="body-2 text--secondary">{{count}} registros</span>
            </v-col>
            <v-col cols="6" class="text-right">
              <v-pagination v-model="page" :length="totalPages" total-visible="6" />
            </v-col>
          </v-row>
          <!-- end acknowledgment -->
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import VTableHeaders from '@/components/VTable/VTableHeaders'
import ListViewMixin from '@/mixins/ListViewMixin'

export default {
  components: {
    VTableHeaders
  },
  mixins: [
    ListViewMixin
  ],
  data: () => ({
    headers: [
      { text: 'Estado de respuesta', value: 'code', class: 'font-weight-bold', sortable: true },
      { text: 'Documento', value: 'document' },
      { text: '', value: 'status' },
      { text: 'Fecha', value: 'date', align: 'end', sortable: true },
      { text: 'Total', value: 'total', align: 'end', sortable: true }
    ],
    loaderList: false,
    loaderReport: false,
    statusesAcknowledgment: [
      {
        code: 'RCD',
        name: 'Reclamación por el contenido del documento'
      },
      {
        code: 'RFP',
        name: 'Reclamación por falta parcial de productos'
      },
      {
        code: 'RFT',
        name: 'Reclamación por falta total de productos'
      }
    ],
    valuesAcknowledgment: { ERM: 0, ACD: 0, RCD: 0, RFP: 0, RFT: 0, WAR: 0 },
    statusesInvoiceStatus: [
      {
        code: 'approved',
        name: 'Facturas aceptadas',
        routeQueryValue: '{"cl_status_detail": "Aceptado"}'
      },
      {
        code: 'rejected',
        name: 'Facturas rechazadas',
        routeQueryValue: '{"cl_status_detail": "Rechazado"}'
      }
    ],
    valuesInvoiceStatus: { approved: 0, rejected: 0 }
  }),
  computed: mapState({
    count: state => state.billers.supplierresponsesCount,
    supplierresponsesList: state => state.billers.supplierresponsesList
  }),
  created () {
    this.loaderReport = true

    Promise.all([
      this.$store.dispatch('billers/LIST', {
        resource: 'billers/built_in/supplierresponses/report'
      })
      .then((response) => {
        if (response.data) {
          const dataset = response.data.datasets[0].data
          const labels = response.data.labels
          this.valuesAcknowledgment = Object.fromEntries(labels.map((v, i) => [v, dataset[i]]))
        }
      }),
      this.$store.dispatch('billers/LIST', {
        resource: 'billers/built_in/invoices_status/report'
      })
      .then((response) => {
        if (response.data) {
          const dataset = response.data.datasets[0].data
          const labels = response.data.labels
          this.valuesInvoiceStatus = Object.fromEntries(labels.map((v, i) => [v, dataset[i]]))
        }
      })
    ])
    .finally(() => {
      setTimeout(() => {
        this.loaderReport = false
      }, 1000)
    })
  },
  methods: {
    getList () {
      const query = Object.assign({}, this.$route.query, {
        expand: 'invoice'
      })
      this.loaderList = true

      if (!this.$route.query.code) {
        query.code__in = 'RCD,RFP,RFT'
      }

      this.$store.dispatch('billers/LIST', {
        resource: 'billers/built_in/supplierresponses',
        query: query
      })
      .finally(() => {
        this.loaderList = false
      })
    }
  }
}
</script>